var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiLayer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 11,
    viewBox: "0 0 37 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3181 10.2568H26.3379L29.0919 0.625287H31.0722L28.3181 10.2568Z",
    fill: "#66686C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2901 0.930025C27.1528 0.746752 26.941 0.65427 26.6534 0.65427H15.7642L15.2249 2.5407H17.2062V2.53961H25.1309L24.5544 4.55552H16.6295L16.6302 4.55134H14.6497L13.0059 10.2979H14.9874L16.0906 6.44086H24.9988C25.277 6.44086 25.5388 6.34897 25.7851 6.1652C26.0308 5.98123 26.1926 5.7544 26.2701 5.48352L27.3731 1.62573C27.4536 1.3458 27.4258 1.1135 27.2901 0.930025Z",
    fill: "#66686C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8519 9.6556C11.7425 10.037 11.3839 10.3008 10.9751 10.3008H0.758026C0.479625 10.3008 0.272699 10.2089 0.13663 10.0253C0.000664712 9.84155 -0.0284999 9.61423 0.0492388 9.34344L2.54222 0.65342H4.5243L2.2976 8.41494H10.2261L12.4528 0.65342H14.4345L11.8519 9.6556Z",
    fill: "#66686C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4923 0.643613L36.9994 5.47187L31.729 10.2988L34.4923 0.643613Z",
    fill: "#27803B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7348 0.643613L35.2401 5.47187L29.9675 10.2988L32.7348 0.643613Z",
    fill: "#E9661C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiLayer);
export default __webpack_public_path__ + "static/media/UPI_Layer.af6b281df513e21c53fd04d8a8ebe707.svg";
export { ForwardRef as ReactComponent };